<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.NOTIFICATION.CREATE_OR_UPDATE.SHOW"
    :handler="(data) => openEditor(data)"
  />

  <DialogComponent ref="modal" type="modal" noInnerPadding hideCloseButton>
    <div class="w-full h-full flex flex-col overflow-auto p-4 bg-slate-50">
      <div class="mobile-status-padding"></div>

      <!-- HEADER -->
      <div class="flex justify-between items-center mb-6">
        <button
          class="w-12 h-12 p-3 rounded-full bg-slate-200"
          @click="() => $refs.modal.hide()"
        >
          <ColorImg
            class="w-full h-full bg-primary -rotate-90"
            src="/images/all/arrow-up.svg"
          />
        </button>
        <h2 class="text-2xl font-semibold text-primary">
          Nouvelle notification
        </h2>
        <div class="w-12"></div>
      </div>

      <!-- FORM -->
      <div class="flex-1 space-y-4">
        <!-- TITLE -->
        <div class="bg-white rounded-xl p-4">
          <label class="block mb-2 text-sm font-medium text-gray-700">
            Titre
          </label>
          <input
            v-model="form.title"
            type="text"
            class="inputComponent w-full"
            placeholder="Ex: Maintenance prévue"
          />
        </div>

        <!-- DESCRIPTION -->
        <div class="bg-white rounded-xl p-4">
          <label class="block mb-2 text-sm font-medium text-gray-700">
            Description
          </label>
          <textarea
            v-model="form.description"
            class="inputComponent w-full"
            rows="4"
            placeholder="Détails de la notification..."
          ></textarea>
        </div>

        <!-- COUNTRY -->
        <div class="bg-white rounded-xl p-4">
          <label class="block mb-2 text-sm font-medium text-gray-700">
            Pays
          </label>
          <select v-model="form.country" class="inputComponent w-full">
            <option
              v-for="(country, code) in $constants.NOTIFICATION.COUNTRIES"
              :key="code"
              :value="code"
            >
              {{ country.flag }} {{ country.name }}
            </option>
          </select>
        </div>
      </div>

      <!-- ACTIONS -->
      <div class="grid grid-cols-2 gap-3 mt-6 pt-4 border-t border-gray-200">
        <button
          class="px-6 py-3 rounded-xl bg-gray-200 text-gray-700 font-medium"
          @click="() => $refs.modal.hide()"
        >
          Annuler
        </button>
        <button
          class="px-6 py-3 rounded-xl bg-primary-600 text-white font-medium hover:bg-primary-700"
          @click="submit"
        >
          Créer
        </button>
      </div>
    </div>
  </DialogComponent>
</template>

<script>
export default {
  name: 'NotificationEditor',

  data() {
    return {
      form: {
        title: '',
        description: '',
        country: 'ANY'
      }
    };
  },

  methods: {
    openEditor(notification) {
      if (notification) {
        this.form = {
          title: notification.title || '',
          description: notification.description || '',
          country: notification.country || 'ANY'
        };
      } else {
        this.form = {
          title: '',
          description: '',
          country: 'ANY'
        };
      }
      this.$refs.modal.show();
    },

    submit() {
      const payload = { ...this.form, action: 'create' };
      this.$bus.emit(this.$constants.EVENTS.NOTIFICATION.SUBMIT, payload);
      this.$refs.modal.hide();
    }
  }
};
</script>
